module.exports = __webpack_public_path__ + "img/source3_2.531a4275.png";